<template>
	<header class="cs-center-header-wrapper"></header>
</template>

<script>
import mixins from '@/mixins'

export default {
	name: 'CsCenterHeader',
	mixins: [mixins],
}
</script>

<style lang="scss" scoped>
.cs-center-header-wrapper {
	background: #fef9ec;
	background-image: url(~@/assets/svg/cs_bg.svg);
	background-size: 100% 100%;
	background-repeat: no-repeat;
	width: 100%;
	height: 160px;
}

/* 모바일: 배너를 낮게 */
html.is-mobile .cs-center-header-wrapper {
	height: 84px;
}
</style>
